//Used to decide if the attribute value have to be retrieved from NetworkElementAttributes or HierarchyElementAttributes
export enum ElementAttributeTypeEnum {
  HierarchyElements = 1,
  NetworkElements = 2,
}
